import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaCostituzioneEditComponent.vue?vue&type=template&id=a7c622c4"
import script from "./RsaSchedaRelazioneSanitariaCostituzioneEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaCostituzioneEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports